import React from 'react'
import { ContainerComponent, ParagraphComponent, SubtitleComponent, TitleComponent } from '../../components'
import './downloads.style.scss'
import { Trans, withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

function Downloads({ t }: { t: any }) {
    return (
        <div className='downloads'>
            <Helmet>
                <title>{t('downloads.meta.title')}</title>
                <meta name="description" content={t('downloads.meta.description')} />
            </Helmet>
            <ContainerComponent>
                <Trans>
                    <TitleComponent smaller centered>{t('downloads.title')}</TitleComponent>
                    {/* <SubtitleComponent>{t('downloads.subtitle')}</SubtitleComponent> */}
                    <div className="downloadables">
                        <ParagraphComponent white><a href="https://tesenergy.hr/assets/pdfs/TESE.pdf">{t('downloads.brochures.1')}</a></ParagraphComponent>
                    </div>
                </Trans>

            </ContainerComponent>

        </div>
    )
}

export default withTranslation()(Downloads);
